import { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import gsap from 'gsap'
import { FireIcon } from '../components/Icons'
import './NotFound.css'

export default function NotFound() {
  const pageRef = useRef(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ delay: 0.3 })

      tl.fromTo('.notfound-icon',
        { opacity: 0, scale: 0, rotate: -180 },
        { opacity: 1, scale: 1, rotate: 0, duration: 0.8, ease: 'back.out(1.7)' }
      )
      .fromTo('.notfound-404',
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out' },
        '-=0.3'
      )
      .fromTo('.notfound-title',
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out' },
        '-=0.3'
      )
      .fromTo('.notfound-description',
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.5, ease: 'power3.out' },
        '-=0.2'
      )
      .fromTo('.notfound-buttons',
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.5, ease: 'power3.out' },
        '-=0.2'
      )

      // Floating drumsticks animation
      gsap.to('.floating-drumstick-1', {
        y: -20,
        rotation: 10,
        duration: 2,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true
      })

      gsap.to('.floating-drumstick-2', {
        y: 15,
        rotation: -15,
        duration: 2.5,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        delay: 0.5
      })

      gsap.to('.floating-drumstick-3', {
        y: -15,
        rotation: 8,
        duration: 1.8,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        delay: 0.8
      })

      // Fire icon pulse
      gsap.to('.fire-icon', {
        scale: 1.1,
        duration: 0.5,
        ease: 'power2.inOut',
        repeat: -1,
        yoyo: true
      })

    }, pageRef)

    return () => ctx.revert()
  }, [])

  return (
    <div className="notfound-page" ref={pageRef}>
      {/* <div className="notfound-bg">
        <div className="notfound-bg-pattern"></div>
        <div className="floating-drumstick floating-drumstick-1">
          <img src="/drumstick.png" alt="" width={60} />
        </div>
        <div className="floating-drumstick floating-drumstick-2">
          <img src="/drumstick.png" alt="" width={45} />
        </div>
        <div className="floating-drumstick floating-drumstick-3">
          <img src="/drumstick.png" alt="" width={35} />
        </div>
      </div> */}

      <div className="notfound-container container">
        <div className="notfound-content">
          <div className="notfound-icon">
            <img src="/drumstick.png" alt="Drumstick" width={100} />
            <span className="fire-icon">
              <FireIcon size={40} />
            </span>
          </div>

          <div className="notfound-404">
            <span className="four">4</span>
            <span className="zero">
              <img src="/drumstick.png" alt="Drumstick" width={150} />
            </span>
            <span className="four">4</span>
          </div>

          <h1 className="notfound-title">
            Oops! This Chicken<br />
            <span className="highlight">Flew the Coop!</span>
          </h1>

          <p className="notfound-description">
            Looks like this page got too crispy and disappeared! 
            Don't worry, we've got plenty more delicious content for you to explore.
          </p>

          <div className="notfound-buttons">
            <Link to="/" className="btn btn-primary">
              Back to Home
            </Link>
            <Link to="/stores" className="btn btn-secondary">
              Find a Store
            </Link>
          </div>
        </div>
      </div>

      <div className="notfound-footer">
        <p>Lost? Try our <Link to="/contact">Contact page</Link> for help!</p>
      </div>
    </div>
  )
}
